import { DrawAction, DrawActionElement } from '../draw-action';

export class StampDrawAction extends DrawAction {

    drawActionElement: DrawActionElement = DrawActionElement.STAMP;
    svgURL: string;

    constructor(svgURL: string) {
        super();
        this.svgURL = svgURL;
    }
}
